import { animated, config, easings, useSpring } from '@react-spring/three';

type Props = {
  children: React.JSX.Element;
  disabled?: boolean;
  angle?: number;
  duration?: number;
};

export const Spinner = ({
  children,
  disabled = false,
  angle: angleProp = Math.PI / 20,
  duration = 3000,
}: Props) => {
  const angle = disabled ? 0 : angleProp;

  const { rotate } = useSpring({
    from: {
      rotate: 0,
    },
    to: { rotate: angle },
    config: disabled
      ? config.stiff
      : {
          duration,
          easing: easings.easeInOutSine,
        },
    loop: {
      from: { rotate: angle },
      to: { rotate: -1 * angle },
      loop: { reverse: true },
    },
  });

  return <animated.group rotation-y={rotate}>{children}</animated.group>;
};
